import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Icon } from '../../../../../components';

const StyledExternalLinkContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  cursor: pointer;

  &:hover {
    opacity: 0.7;
  }
`;

const ExternalLinkRenderer = ({ data }) => {
  if (!data) return null;

  const url = `https://app.supper.co/chats/${data.conversationId}?organization_id=${data.organizationId}#${data.id}`;

  const handleClick = () => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleClick();
    }
  };

  return (
    <StyledExternalLinkContainer
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      tabIndex={0}
      role='button'
      title='Open in new tab'
      aria-label='Open question in new tab'
    >
      <Icon name='external-link' color='var(--content-subtitle)' displaySize={20} />
    </StyledExternalLinkContainer>
  );
};

ExternalLinkRenderer.propTypes = {
  data: PropTypes.shape({
    conversationId: PropTypes.string.isRequired,
    organizationId: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired
  }).isRequired
};

export { ExternalLinkRenderer };
